import React from 'react';
import Loadable from 'react-loadable';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);

let ListPageComponent = false;
let ListPageComponentLegacy = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  ListPageComponent = require('./world_changing_ideas_list_page').default;
  // eslint-disable-next-line global-require
  ListPageComponentLegacy = require('./world_changing_ideas_list_page_legacy')
    .default;
}
/**
 * List Lander Page
 */
export function wciListPage(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(list)',
    component() {
      if (ListPageComponent) {
        return <ListPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponent ? ListPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page').then(resp => {
        ListPageComponent = resp.default;
        routeConfig.loadData = ListPageComponent.loadData(store);

        return ListPageComponent;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

/**
 * List Lander Page old
 */
export function wciListPageLegacy(store) {
  const routeConfig = {
    path: '/world-changing-ideas/:page(2022)',
    component() {
      if (ListPageComponentLegacy) {
        return <ListPageComponentLegacy />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: ListPageComponentLegacy
      ? ListPageComponentLegacy.loadData(store)
      : false,
    preloadChunk() {
      return import('./world_changing_ideas_list_page_legacy').then(resp => {
        ListPageComponentLegacy = resp.default;
        routeConfig.loadData = ListPageComponentLegacy.loadData(store);

        return ListPageComponentLegacy;
      });
    },
    chunk: 'wciListPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
